import { createRouter, createWebHashHistory } from 'vue-router'
import MakeIndex from '../views/MakeIndex.vue'
import UserCenter from '../views/UserCenter.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: MakeIndex
  },
  {
    path: '/user',
    name: 'user',
    component: UserCenter,
    redirect: "/works",
    // 动态修改组件
    children: [
      {
        path: '/works',
        name: 'works',
        component: () => import('@/views/Works.vue')
      },
      {
        path: '/draft',
        name: 'draft',
        component: () => import('@/views/Draft.vue')
      },
      {
        path: '/account',
        name: 'account',
        component: () => import('@/views/Account.vue')
      },
      {
        path: '/support',
        name: 'support',
        component: () => import('@/views/Support.vue')
      },
    ]
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
